<div [matTooltip]="fullName" [matTooltipPosition]="'above'" [class]="'userAvatarContainer ' + size" [ngClass]="{'isAdmin': isAdmin}">
  @if (avatar) {
    <figure class="user-avatar">
      <img [src]="avatar" [alt]="fullName">
    </figure>
  }
  @if (!avatar) {
    <div class="user-initials">
      {{initials}}
    </div>
  }
</div>
